// extracted by mini-css-extract-plugin
export default {"projectItem":"projectItem_wahH"};